<template>
    <template v-if="isLoading">
      <!-- NO DATA -->
    </template>
    <template v-else-if="showFileNm">
      <a v-for="(item, idx) in items" :key="idx" @click.stop="clickFunc(idx)" class="kb-mouse-cursor" :class="addLinkClass" :style="addLinkStyle">
        <span :class="addTextClass" :style="addTextStyle">{{ item.fileNm }}<i v-if="showIcon" :class="iconClass"></i></span>
      </a>
    </template>
    <template v-else-if="items.length === 1">
      <a v-for="(item, idx) in items" :key="idx" @click.stop="clickFunc(idx)" class="kb-mouse-cursor" :class="addLinkClass" :style="addLinkStyle">
        <span :class="addTextClass" :style="addTextStyle">{{ item.btnNm }}<i v-if="showIcon" :class="iconClass"></i></span>
      </a>
    </template>
    <template v-else>
      <a @click.stop="showFileList = !showFileList" class="kb-mouse-cursor" :class="addLinkClass" :style="addLinkStyle">
        <span :class="addTextClass" :style="addTextStyle">{{ btnNm }}<i v-if="showIcon" :class="iconClass"></i></span>
      </a>
      <div v-if="showFileList" class="file-down-link-list">
        <ul class="d-flex flex-column">
          <li v-for="(item, idx) in items" :key="idx" @click.stop="clickFunc(idx)" class="d-flex justify-content-between kb-mouse-cursor mb-2">
            <span class="text-muted me-2">{{ item.fileNm }}</span>
            <span class="text-muted">{{convertToStorageBytes(item.fileSz)}}</span>
          </li>
        </ul>
      </div>
    </template>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import {downloadFileDownMng, getFileDownMng} from "@/assets/js/modules/common/filedown";
import {convertToStorageBytes} from "@/assets/js/util";

export default {
  name: 'FileDownLink',
  props: {
    fileKey: String,
    addLinkClass: {
      type: Array,
      default: () => ['text-link'],
    },
    addTextClass: {
      type: Array,
      default: () => ['text','ms-lg-2'],
    },
    addLinkStyle: String,
    addTextStyle: String,
    iconClass: {
      type: String,
      default: 'icon-download',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showFileNm: {
      type: Boolean,
      default: false,
    },
    clickPreFunc: {
      type: Function,
      default: () => {return true;}
    }
  },
  setup(props){
    const items = ref([]);
    const btnNm = ref('');
    const isLoading = ref(true);
    const showFileList = ref(false);

    const getFileInfo = () => {
      isLoading.value = true;
      getFileDownMng(props.fileKey, items, () => {
        if(items.value.length > 0) isLoading.value = false;
      })
    }

    const clickFunc = async (idx) => {
      if(await props.clickPreFunc()) {
        await downloadFileDownMng(items.value[idx].fileDownId, items.value[idx].comFileAtchSn);
      }
    }

    watch(() => items.value, () => {
      if(items.value.length > 0){
        btnNm.value = items.value[0].btnNm;
      }
    })

    onMounted(getFileInfo)

    return {
      items,
      btnNm,
      isLoading,
      showFileList,
      clickFunc,
      downloadFileDownMng,
      convertToStorageBytes,
    }
  }
}
</script>

<style>
.file-down-link-list {
  position: absolute;
  top: 48px;
  z-index: var(--kb-zindex-dropdown);
  width: max-content;
  border: 1px solid var(--kb-border-color);
  border-radius: var(--kb-border-radius);
  background-color: rgba(255,255,255,0.9);
  padding: 10px;
}
</style>